// Responsive horizontal gutter + centered max width (mobile < md, tablet md,
// desktop lg+), shared with MarketingContent.
export const containerPx = 'px-5 md:px-8 lg:px-16 lg:max-w-screen-xl lg:mx-auto';
